var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "figure",
    _vm._g(
      _vm._b(
        { staticClass: "figure", class: _vm.data.staticClass || "" },
        "figure",
        { attrs: _vm.attrs },
        false
      ),
      _vm.listeners
    ),
    [
      _vm._t("image"),
      _vm._v(" "),
      _c(
        "figcaption",
        { staticClass: "figure__caption" },
        [_vm._t("caption")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }